import { spacing3x, spacing4x, spacing12x } from "@airhelp/design-tokens";
const variantOutline = (props) => {
    const { colorScheme } = props;
    return {
        field: {
            fontSize: "md",
            border: "1px",
            borderColor: "greyscale.500",
            borderRadius: "md",
            color: "font.primary",
            bg: "greyscale.100",
            paddingY: spacing3x,
            paddingX: spacing4x,
            height: spacing12x,
            lineHeight: "base",
            _hover: {
                borderColor: { md: "primary.300" },
                _disabled: {
                    opacity: 1,
                    bg: "greyscale.300",
                    borderColor: "greyscale.500",
                },
            },
            _focus: {
                boxShadow: "none",
                bg: "greyscale.100",
                borderColor: "primary.500",
            },
            _readOnly: {
                boxShadow: "none",
                userSelect: "all",
            },
            _disabled: {
                opacity: 1,
                color: "greyscale.500",
                bg: "greyscale.300",
            },
            _invalid: {
                boxShadow: "none",
                borderColor: colorScheme === "warning" ? `${colorScheme}.600` : "danger.700",
                _hover: {
                    borderColor: { md: colorScheme === "warning" ? `${colorScheme}.700` : "danger.800" },
                },
                _focus: {
                    borderColor: "primary.500",
                },
            },
            _placeholder: {
                color: "greyscale.500",
            },
        },
        addon: {
            background: "greyscale.300",
            borderColor: "greyscale.500",
            color: "greyscale.500",
            height: spacing12x,
            minWidth: "65px",
        },
    };
};
const variants = {
    outline: variantOutline,
};
const defaultProps = {
    colorScheme: "danger",
    variant: "outline",
};
const Input = {
    variants,
    defaultProps,
};
export default Input;
